import { mapActions } from "vuex";
import * as types from "@/store/types";
import { InitService, KycService } from "@/services";

const uploadCard = () =>
  import(
    /* webpackChunkName: "uploadCard" */ "@/components/AccountPage/Kyc/AutoKyc/InternationalCard/UploadCard/index"
  );

const noWebcam = () =>
  import(
    /* webpackChunkName: "noWebcam" */ "@/components/AccountPage/Kyc/NoWebcam/index"
  );

export default {
  name: "international-card",
  components: { uploadCard, noWebcam },
  data() {
    return {
      kycGuidImage: require("@/assets/image/kyc-guid.png"),
      isModalOpen: false,
      frontImg: null,
      backImg: null,
      isUploadModalOpen: false,
      progress: 0
    };
  },
  computed: {
    activeButton() {
      if (this.backImg && this.frontImg) return false;
      return true;
    }
  },
  mounted() {
    this.getInit();
  },
  methods: {
    ...mapActions({
      setInit: types.init.actions.SET_INIT_DATA
    }),
    getInit() {
      InitService.init().then(res => {
        this.setInit(res.data.data);
      });
    },
    closeGuidModal() {
      this.isModalOpen = false;
    },
    openGuidModal() {
      this.isModalOpen = true;
    },
    continueKyc() {
      this.uploadInternationalCard();
    },
    onUploadFront(data) {
      this.frontImg = data;
    },
    onUploadBack(data) {
      this.backImg = data;
    },
    uploadInternationalCard() {
      const data = { front: this.frontImg, back: this.backImg };
      this.isUploadModalOpen = true;
      KycService.verificationInternationalCard(data, event => {
        if (event.loaded === event.total) this.isUploadModalOpen = false;
      }).then(() => {
        this.$router.push({ name: "video" });
      });
    }
  }
};
